export default __webpack_public_path__ + "static/media/DiaphragmPumps.c69713bd.jpg";